<template>
  <swiper
    v-if="enabled && slides.length > itemsPerSlide"
    :options="swiperOption"
    class="calc-swiper"
  >
    <swiper-slide
      v-for="(slide, i) in slides"
      :key="slideKey ? slide[slideKey] : i"
    >
      <div class="slide-wrapper">
        <slot :slide="slide" />
      </div>
    </swiper-slide>
    <!-- Optional controls -->
    <div class="swiper-pagination" slot="pagination"></div>
    <!-- If we need navigation buttons -->
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
  <div v-else class="choice">
    <div
      v-for="(slide, i) in slides"
      :key="slideKey ? slide[slideKey] : i"
      :style="{ flexBasis: `${100 / itemsPerSlide}%` }"
      class="choice__col"
    >
      <slot :slide="slide" />
    </div>
    <div class="vue-choice-button-wrapper" v-if="buttonInside">
      <next-step-button
        :disabled="false"
        :selected-option="selectedOption"
        :gtm="gtm"
      />
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import NextStepButton from "@/components/ui/NextStepButton";

export default {
  components: {
    swiper,
    swiperSlide,
    NextStepButton
  },
  props: {
    slides: {
      type: Array,
      required: true
    },
    itemsPerSlide: {
      type: Number,
      required: false,
      default: 4
    },
    slideKey: {
      type: String
    },
    enabled: {
      type: Boolean,
      default: () => true
    },
    selectedOption: {
      required: true
    },
    buttonInside: {
      type: Boolean,
      default: false
    },
    gtm: {
      required: true
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: this.itemsPerSlide,
        slidesPerGroup: this.itemsPerSlide,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        preventClicks: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          // when window width is >= 640px
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 10
          }
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.swiper-container {
  overflow: visible;
}

.slide-wrapper {
  height: 100%;
}

.swiper-container.calc-swiper {
  padding-bottom: 30px;
}

.choice {
  @include flex-grid(30px, 50%, 50%, 25%, 0, 0, 10px);
  justify-content: center;

  &--small {
    @include flex-grid(14px, 50%, 50%, 16%, 0, 0, 10px);
  }

  @include media("<tablet") {
    &__col {
      flex-basis: 50% !important;
    }
  }

  @include media(">=desktop") {
    //margin-top: -70px;
    //margin-bottom: -90px;
  }
}

.vue-choice-button-wrapper {
  display: flex;
  padding: 10px;

  > * {
    flex: 1 1 auto;
  }
}
</style>
